module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>location</title><path d=\"M24.42.5A16.41,16.41,0,0,0,7.68,17.17,19.51,19.51,0,0,0,9.05,23.4c4.67,10.16,8.34,15.93,15.4,26.1,7.15-10.65,11.12-16,15.79-26.1a19.14,19.14,0,0,0,1-6.23A16.46,16.46,0,0,0,24.42.5Zm-.12,27A10.19,10.19,0,1,1,34.4,17.3,10.14,10.14,0,0,1,24.3,27.49Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/location.svg
// module id = 498
// module chunks = 1